import { admGraphqlRequest } from 'core/utils/backend-service';
import {
    deleteEapSettingsMutation,
    getConfigurationEAPSettingsListQuery,
    getEapSettingByIdQuery,
    getMissingEapCertificatesQuery,
} from './device-configuration-eap-settings.queries';
import {
    EapSettingAPI,
    MissingCertificatesInput,
    MissingCertificatesResponse,
} from './device-configuration-eap-settings.api';

export const getDeviceConfigurationEAPSettingsList = (): Promise<EapSettingAPI[]> =>
    admGraphqlRequest(getConfigurationEAPSettingsListQuery()).then((result) => result.data.eapSettings);

export const getEapSettingById = (id: string): Promise<EapSettingAPI> =>
    admGraphqlRequest(getEapSettingByIdQuery(), { id }).then((result) => result.data.eapSetting);

export const deleteEapSettings = (ids: string[]): Promise<void> =>
    admGraphqlRequest(deleteEapSettingsMutation(), { ids }).then((result) => result.data.deleteEapSettings);

export const getMissingEapCertificates = (certs: MissingCertificatesInput): Promise<MissingCertificatesResponse> =>
    admGraphqlRequest(getMissingEapCertificatesQuery(), { certs }).then(
        (result) => result.data.getMissingEapCertificates
    );
